// extracted by mini-css-extract-plugin
export default {"formInput":"FormInput_formInput__8ICBm","invalidInput":"FormInput_invalidInput__pcdja","vectorImg":"FormInput_vectorImg__eDepY"};